<template>
	<div class='admin_dashboard'>
		<div class="container-fluid">
      		<div class="container">
				<div  class="w-100 border-bottom border-green-lighter mb-3">
					<h1 class="display-4" style='margin: 0.5rem 1rem;'>Dashboard</h1>
				</div>
				
				<div class='admin_dashboard__row'>
					<div class='admin_dashboard__card admin_dashboard__card--2'>
						<page-views-chart></page-views-chart>
						<div class='admin_dashboard__card__title'>{{ $t('forum_page_views_past_week') }}</div>
					</div>
					<div class='admin_dashboard__card admin_dashboard__card--2'>
						<new-posts></new-posts>
						<div class='admin_dashboard__card__title'>{{ $t('forum_new_threads_24_hours') }}</div>
					</div>
				</div>
				<div class='admin_dashboard__row'>
					<div class='admin_dashboard__card admin_dashboard__card--2'>
						<categories-chart></categories-chart>
						<div class='admin_dashboard__card__title'>{{ $t('forum_numbre_of_threads') }}</div>
					</div>
					<div class='admin_dashboard__card admin_dashboard__card--2'>
						<top-posts></top-posts>
						<div class='admin_dashboard__card__title'>{{ $t('forum_top_threads') }}</div>
					</div>
				</div>
				<div class='admin_dashboard__row'>
					<div class='admin_dashboard__card admin_dashboard__card--2'>
						<new-users-chart></new-users-chart>
						<div class='admin_dashboard__card__title'>{{ $t('forum_new_users_past_week') }}</div>
					</div>
					<div class='admin_dashboard__card admin_dashboard__card--2 admin_dashboard__card--hidden'></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NewPosts from '../widgets/NewPosts'
	import PageViewsChart from '../widgets/PageViewsChart'
	import NewUsersChart from '../widgets/NewUsersChart'
	import CategoriesChart from '../widgets/CategoriesChart'
	import TopPosts from '../widgets/TopPosts'

	export default {
		name: 'AdminDashboard',
		components: {
			NewPosts,
			PageViewsChart,
			NewUsersChart,
			CategoriesChart,
			TopPosts
		},
		mounted () {
			this.$store.dispatch('setTitle', 'admin | dashboard')
		}
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/variables.scss';

	.admin_dashboard {

		@at-root #{&}__row {
			display: flex;
		}

		@at-root #{&}__card {
			margin: 1rem;
			height: 12rem;
			background-color: #fff;
			border-radius: 0.25rem;
			flex: 1;
			display: flex;
			flex-direction: column;

			@extend .shadow_border;

			@for $i from 1 through 5 {
				@at-root #{&}--#{$i} {
					flex: $i;
				}
			}

			@at-root #{&}--hidden {
				visibility: hidden;
			}

			@at-root #{&}__title {
				background-color: #13181d;
				color: #fff;
				width: 100%;
				padding: 0.25rem 0.35rem;
				box-shadow: 0 0.1rem 0.075rem rgba(175, 175, 175, 0.25);
				border-radius: 0 0 0.25rem 0.25rem;
				cursor: default;
				font-size: 0.9rem;
			}
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.admin_dashboard {
			@at-root #{&}__row {
				display: block;
			}
		}
	}
</style>